import { useState, useEffect } from 'react'
import Select from 'react-select'
import { useLocation } from 'react-router';
import { TooltipComponent, TooltipComponentMobile } from '../../Tooltip';

const MajorCollegeSearch = ({ collegeOptions, setCollegeSelect, resetStateToggle, mobile = false }) => {

  const location = useLocation()
  const [selectedColleges, setSelectedColleges] = useState<any>([]);

  const handleCollegeSelectChange = (selectedColleges) => {
    setSelectedColleges(selectedColleges);
    let collegeArr: any = []
    selectedColleges.map((college) =>
      collegeArr.push(college.value))
    setCollegeSelect(collegeArr)
  }

  useEffect(() => {
    setSelectedColleges([])
  }, [resetStateToggle])

  useEffect(() => {

    let params = new URLSearchParams(location.search);
    let namesParam = params.get('collegeName');

    if (namesParam) {

      let res: any[] = []
      namesParam.split(',').map(val => {
        let collegeObj = collegeOptions.find((obj => obj.value === parseInt(val)))

        if (collegeObj) {
          res.push(collegeObj)
        }
      })

      if (res.length > 0) {
        handleCollegeSelectChange(res)
      }

      else {
        setSelectedColleges([])
      }
    }

    else {
      setSelectedColleges([])
    }

  }, [location.search, collegeOptions]);

  return (
    <div className='mt-4 d-flex flex-column'>
      <div className={`dca-aside-header ${mobile ? 'd-flex flex-row' : ''}`}>COLLEGE {mobile ? <span className="ms-2"><TooltipComponentMobile content={"Use this filter to explore majors offered by one or more selected college(s). Click on a result to see details about that major at each offering college."} /></span> : <TooltipComponent content={"Use this filter to explore majors offered by one or more selected college(s). Click on a result to see details about that major at each offering college."} />}</div>
      <Select
        options={collegeOptions}
        styles={{
          control: (baseStyles, state) => ({
            ...baseStyles,
            border: 'transparent',
            backgroundColor: '#F9F9F9',
          }),
          menu: (baseStyles) => ({
            ...baseStyles,
            zIndex: 100
          })
        }}
        isMulti
        value={selectedColleges}
        onChange={handleCollegeSelectChange}
      />
    </div>
  )
}

export { MajorCollegeSearch }